import {RemoteAcceptWellBornProgram} from 'data/usecases/private/well-born/remote-accept-program';
import {PostAcceptWellBornProgram} from 'domain/usecases/private/well-born/post-accept-well-born-program';
import {makeAxiosHttpClient} from 'main/factories/http/axios-http-client-factory';
import {WellBornEndpoints} from 'main/factories/usecases/endpoints';

export const makePostAcceptWellBornProgram = (): PostAcceptWellBornProgram =>
	new RemoteAcceptWellBornProgram(WellBornEndpoints.acceptProgram, makeAxiosHttpClient());
